module.exports = __webpack_public_path__ + "assets/img/loginIcon3.d685d5be.png";